import React from "react";
import { TextLoading } from "../components/TextLoading/TextLoading";
import { useSignal } from "@preact/signals-react";
import { BlankV2 } from "../Blank/BlankV2";
import styles from "./Html.module.scss";
function Html(props) {
  var createBlobUrl = props.createBlobUrl,
    uuid = props.uuid,
    loading = props.loading;
  var iframeId = "iframe_" + props.id;
  var previewStyle = useSignal({});
  var realWidth = useSignal(false);
  if (!(createBlobUrl !== null && createBlobUrl !== void 0 && createBlobUrl.streaming) && loading) {
    realWidth.value = false;
  }
  if (!(createBlobUrl !== null && createBlobUrl !== void 0 && createBlobUrl.objectURL)) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.blankNode
    }, /*#__PURE__*/React.createElement(BlankV2, null));
  }
  // streaming 字段是来自custom api，websocket，频繁的返回进度条。应对这个情况新增加的字段
  if (!(createBlobUrl !== null && createBlobUrl !== void 0 && createBlobUrl.streaming) && loading) return /*#__PURE__*/React.createElement(TextLoading, null);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.content,
    style: previewStyle.value
  }, realWidth.value && /*#__PURE__*/React.createElement("iframe", {
    id: iframeId,
    title: uuid,
    className: styles.HtmlContainer,
    src: createBlobUrl === null || createBlobUrl === void 0 ? void 0 : createBlobUrl.objectURL,
    onLoad: function onLoad() {
      var _document$getElementB;
      var body = (_document$getElementB = document.getElementById(iframeId)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.contentWindow.document.getElementsByTagName("body")[0];
      var bodyHeight = body.scrollHeight;
      var bodyWidth = body.scrollWidth;
      if (props.changeSizeByIframe) {
        if (!(createBlobUrl !== null && createBlobUrl !== void 0 && createBlobUrl.streaming)) {
          var _props$changeSizeByIf;
          (_props$changeSizeByIf = props.changeSizeByIframe) === null || _props$changeSizeByIf === void 0 || _props$changeSizeByIf.call(props, bodyWidth + 30, bodyHeight + 80);
        }
      } else {
        if (!(createBlobUrl !== null && createBlobUrl !== void 0 && createBlobUrl.streaming)) {
          previewStyle.value = {
            width: "100%",
            height: bodyHeight + 20
          };
        }
      }
    }
  }), !realWidth.value && /*#__PURE__*/React.createElement("iframe", {
    id: iframeId,
    title: uuid,
    className: styles.HtmlContainer,
    src: createBlobUrl === null || createBlobUrl === void 0 ? void 0 : createBlobUrl.objectURL,
    onLoad: function onLoad() {
      var _document$getElementB2;
      var body = (_document$getElementB2 = document.getElementById(iframeId)) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.contentWindow.document.getElementsByTagName("body")[0];
      var bodyWidth = body.scrollWidth;
      if (props.changeSizeByIframe && !(createBlobUrl !== null && createBlobUrl !== void 0 && createBlobUrl.streaming)) {
        var _props$changeSizeByIf2;
        (_props$changeSizeByIf2 = props.changeSizeByIframe) === null || _props$changeSizeByIf2 === void 0 || _props$changeSizeByIf2.call(props, bodyWidth + 30, 500);
      }
      realWidth.value = true;
    }
  }));
}
export { Html };